import { create } from 'zustand';

interface ChartSettings {
  appreciationRate: number;     // Jährliche Wertsteigerung in %
  rentIncreaseRate: number;     // Jährliche Mietsteigerung in %
  refinanceRate: number;        // Zinssatz bei Anschlussfinanzierung in %
  yearsToProject: number;       // Anzahl Jahre für Projektion
}

interface DashboardState {
  chartSettings: ChartSettings;
  setChartSettings: (settings: Partial<ChartSettings>) => void;
  resetChartSettings: () => void;
}

const defaultSettings: ChartSettings = {
  appreciationRate: 2.0,
  rentIncreaseRate: 1.5,
  refinanceRate: 4.0,
  yearsToProject: 10,
};

export const useDashboardStore = create<DashboardState>((set) => ({
  chartSettings: defaultSettings,
  setChartSettings: (settings) =>
    set((state) => ({
      chartSettings: { ...state.chartSettings, ...settings },
    })),
  resetChartSettings: () => set({ chartSettings: defaultSettings }),
}));
